<template>
    <div>
        <el-card shadow="hover">
            <div>
                <template style="float: left;">
                    <el-button type="primary" size="small" icon="el-icon-document-add" v-has="'PlatAdmin'" @click="doAdd()">添加</el-button>
                    <el-button-group style="margin-left:20px;" v-show="selRows.length > 0">
                        <el-tooltip effect="dark" content="删除" placement="top">
                            <el-button size="small" icon="el-icon-delete" @click="doDelete()"></el-button>
                        </el-tooltip>
                    </el-button-group>
                </template>
                <el-form style="float: right" inline :model="query" size="small">
                    <div @keydown.enter="doQuery()">
                        <el-form-item>
                            <el-select v-model="query.unid" placeholder="请选择招聘单位" style="width:200px;" @change="doQuery" clearable>
                                <el-option v-for="unit in units" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.dept" clearable placeholder="用人单位" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="岗位名称" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.code" clearable placeholder="岗位代码" style="width:150px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" @selection-change="doSelectionChange" style="width: 100%">
                <el-table-column type="selection" width="40" />
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-form label-position="left">
                            <el-form-item label="学历要求">
                                <span>{{ props.row.edu || '无' }}</span>
                            </el-form-item>
                            <el-form-item label="专业要求">
                                <span>{{ props.row.major || '无' }}</span>
                            </el-form-item>
                            <el-form-item label="证书要求">
                                <span>{{ props.row.cert || '无' }}</span>
                            </el-form-item>
                            <el-form-item label="年龄要求">
                                <span>{{ props.row.age || '无' }}</span>
                            </el-form-item>
                            <el-form-item label="备注信息">
                                <span>{{ props.row.memo || '无' }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘单位">
                    <template slot-scope="scope">
                        <span>{{ scope.row.unit.name }}</span>
                        <span v-show="scope.row.unit.dept">[{{ scope.row.unit.dept }}]</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘岗位">
                    <template slot-scope="scope">
                        [{{ scope.row.code }}]
                        <span>{{ scope.row.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="岗位类别及等级" width="200">
                    <template slot-scope="scope">
                        <span>{{ scope.row.cate }}{{ scope.row.level }}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="报名费" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.fee }} 元</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="招聘人数" width="100">
                    <template slot-scope="scope">
                        <span>{{ scope.row.count }}</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" v-has="'PlatAdmin'" @click.stop="doEdit(scope.row)">
                            编辑
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="详情" :visible.sync="formDialog" width="900px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <el-form ref="postForm" :model="field" :rules="rules" label-width="80px">
                <el-row :gutter="10">
                    <el-col :span="12">
                        <el-form-item label="岗位名称" prop="name">
                            <el-input v-model="field.name" tabindex="1" placeholder="请填写岗位名称"></el-input>
                        </el-form-item>
                        <el-form-item label="招聘单位" prop="unid">
                            <el-select v-model="field.unid" filterable placeholder="请选择招聘单位" tabindex="3" style="width:100%;" @change="doChangeUnit">
                                <el-option v-for="unit in units" :key="unit.id" :label="unit.name" :value="unit.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="报名费" prop="fee">
                            <el-input v-model="field.fee" type="number" tabindex="5" placeholder="请填写报名费"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位类别" prop="cate">
                            <el-input v-model="field.cate" tabindex="7" placeholder="请填写岗位类别"></el-input>
                        </el-form-item>
                        <el-form-item label="学历要求" prop="edu">
                            <el-input type="textarea" :rows="3" tabindex="9" v-model="field.edu" placeholder="请填写学历要求"></el-input>
                        </el-form-item>
                        <el-form-item label="证书要求" prop="cert">
                            <el-input type="textarea" :rows="3" tabindex="11" v-model="field.cert" placeholder="请填写证书要求"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="岗位代码" prop="code">
                            <el-input v-model="field.code" tabindex="2" placeholder="请填写岗位代码"></el-input>
                        </el-form-item>
                        <el-form-item label="用人单位" prop="dept">
                            <el-autocomplete v-model="field.dept" tabindex="4" :fetch-suggestions="doSearchUnitDept" style="width: 100%;" placeholder="请填写用人单位"></el-autocomplete>
                        </el-form-item>
                        <el-form-item label="招聘人数" prop="count">
                            <el-input v-model="field.count" tabindex="6" type="number" placeholder="请填写招聘人数"></el-input>
                        </el-form-item>
                        <el-form-item label="岗位级别" prop="level">
                            <el-input v-model="field.level" tabindex="8" placeholder="请填写岗位级别"></el-input>
                        </el-form-item>
                        <el-form-item label="专业要求" prop="major">
                            <el-input type="textarea" :rows="3" v-model="field.major" tabindex="10" placeholder="请填写专业要求"></el-input>
                        </el-form-item>
                        <el-form-item label="年龄要求" prop="age">
                            <el-input type="textarea" :rows="3" v-model="field.age" tabindex="12" placeholder="请填写年龄要求"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="考试科目" prop="items">
                    <el-input v-model="field.items" tabindex="13" placeholder="请填写考试科目，多个以`,`区分，顺序：科目1,科目2,..."></el-input>
                </el-form-item>
                <el-form-item label="备注信息" prop="memo">
                    <el-input type="textarea" :rows="3" v-model="field.memo" tabindex="14" placeholder="请填写备注信息"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" tabindex="15" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    保存
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'PlanPost',
    props: {
        pid: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            query: {
                page: 1,
                size: 10,
                time: 0,
                unid: '',
                dept: '',
                name: '',
                code: ''
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            selRows: [],
            field: {
                id: '',
                unid: '',
                dept: '',
                name: '',
                code: '',
                fee: 0,
                count: 0,
                cate: '',
                level: '',
                items: '',
                edu: '',
                major: '',
                cert: '',
                age: '',
                memo: ''
            },
            rules: {
                unid: [
                    {
                        required: true,
                        message: '请选择招聘单位',
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        required: true,
                        message: '请填写岗位名称',
                        trigger: 'blur'
                    }
                ],
                code: [
                    {
                        required: true,
                        message: '请填写岗位代码',
                        trigger: 'blur'
                    }
                ],
                fee: [
                    {
                        required: true,
                        message: '请填写报名费',
                        trigger: 'blur'
                    }
                ],
                count: [
                    {
                        required: true,
                        message: '请填写招聘人数',
                        trigger: 'blur'
                    }
                ],
                items: [
                    {
                        required: true,
                        message: '请填写考试科目',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            submitLoading: false,
            units: [],
            depts: []
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init() {
            this.doLoad()
            this.doLoadUnit()
        },
        doLoadUnit() {
            this.$http
                .get('/comm/data/unit/query', {
                    params: {
                        _: new Date().getTime(),
                        dept: true
                    }
                })
                .then(result => {
                    this.units = result.datas
                    this.units.forEach(unit => {
                        unit.depts = unit.depts.map(dept => {
                            return {
                                value: dept
                            }
                        })
                    })
                })
        },
        doChangeUnit() {
            this.depts = this.units.find(unit => unit.id === this.field.unid).depts
            this.field.dept = ''
        },
        doSearchUnitDept(str, cb) {
            cb(this.depts)
        },
        doLoad() {
            this.tableLoading = true
            this.query.pid = this.pid
            this.$http
                .get('/ops/recruit/post/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                page: 1,
                size: 10,
                time: 0,
                unid: '',
                dept: '',
                name: '',
                code: ''
            }
            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        doSelectionChange(rows) {
            this.selRows = rows
        },
        clearFields() {
            this.field = {
                id: '',
                unid: '',
                dept: '',
                name: '公开招聘',
                items: '科目1',
                code: '',
                fee: 30,
                count: 0,
                cate: '',
                level: '',
                edu: '',
                major: '',
                cert: '',
                age: '',
                memo: ''
            }
            if (this.$refs['postForm']) {
                this.$refs['postForm'].resetFields()
                this.$refs['postForm'].clearValidate()
            }
        },
        doAdd() {
            this.clearFields()
            this.formDialog = true
        },
        doEdit(item) {
            item.unid = item.unit.id
            item.dept = item.unit.dept
            this.depts = this.units.find(unit => unit.id === item.unid).depts
            this.clearFields()
            this.field = {
                ...item
            }

            this.formDialog = true
        },
        doSubmit() {
            this.$refs['postForm'].validate(valid => {
                if (valid) {
                    this.field.pid = this.pid
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/post/save', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doDelete(item) {
            let names = []
            let ids = []
            if (item) {
                names.push(item.name)
                ids.push(item.id)
            } else {
                this.selRows.forEach(row => {
                    names.push(row.name)
                    ids.push(row.id)
                })
            }
            if (ids.length === 0) {
                this.$message.error('请选择要删除的内容')
                return
            }
            this.$confirm('是否删除[' + names.join() + ']?删除后将无法恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http
                    .post('/ops/recruit/post/delete', {
                        ids: ids.join()
                    })
                    .then(result => {
                        if (result.code === 0) {
                            this.$message.success('删除成功')
                            this.doLoad()
                        }
                    })
            })
        }
    }
}
</script>
